<div class="-sf-container">
  @if (solutionFinderResponse) {
  <div class="-sf-card-row">
    <div class="-sf-content-container">
      <h3>{{ solutionFinderResponse.title }}</h3>
      <p [innerHTML]="solutionFinderResponse.desc"></p>
    </div>
    @if (solutionFinderResponse.path) {
    <app-link [to]="solutionFinderResponse.path">{{ solutionFinderResponse.solutiontitle }}</app-link>
    }
  </div>
  }
</div>
